import { useState, useEffect } from 'react'
import useStateTracker from './../hooks/StateTracker'
import Timer from './Timer'
import { useAuth } from '../hooks/Auth'
import { convertTimestampToTime, convertTimestampToDate } from './../utils'
import { stateDisplays, icons, IDLE_THRESHOLD } from '../constants'


const infoPanelStyle = {
  transition: "right .1s",
  right: -100
}

const openInfoPanelStyle = {
  right: 0
}

const imageStyle = {
  maxWidth: "100%",
  maxHeight: "2rem"
}

const itemStyle = {
  backgroundColor: "#d2d8f7",
  borderRadius: 8,
  boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)"
}

const activeItemStyle = {
  backgroundColor: "#fff",
  border: "2px solid #cccccc",
  borderRadius: 8,
  boxShadow: 0
}

const hoverItemStyle = {
  backgroundColor: "#f6f9fc"
}

const FacilityIcon = ({facility}) => {
  const [time, setTime] = useState(0)
  const iconSrc = icons[facility.state] || icons.default

  useEffect(() => {
    const interval = setInterval(() => setTime(Math.floor(Date.now() / 1000) - facility.update_time), 1000)
    return () => {clearInterval(interval)}
  }, [facility.update_time])

  return (
    <img
      className="align-self-center"
      style={imageStyle}
      alt={facility.state}
      src={'/icons/' + (time < IDLE_THRESHOLD ? iconSrc : icons.default)}
    />
  )
}

const FacilityTab = ({ facility, activeTab, onClick }) => {
  const auth = useAuth()
  const [showPanel, setShowPanel] = useState(false)
  const stateDisplay = stateDisplays[facility.state]
  const isSuperuser = auth.user ? auth?.user.is_superuser : false
  const active = activeTab === facility.id
  const classes = active ? "tab-list-active" : ""
  const show_message = () => {
    return !facility.target_reached && (facility.message && facility.message !== "none")
  }
  const format_message = () => {
    return (facility.message && facility.message !== "none") ?
      facility.message.charAt(0).toUpperCase() + facility.message.slice(1) : ""
  }
  return (
    <div
      className="col-md-2 col-4 px-1 pb-1"
      onClick={() => onClick(facility)}
      onMouseEnter={() => setShowPanel(true)}
      onMouseLeave={() => setShowPanel(false)}
    >
      <div
        className={"row tab-list-item py-1 mb-1 w-100 " + classes}
        style={{...(active ? activeItemStyle : itemStyle), ...(showPanel ? hoverItemStyle : {})}}
      >
        <div className="col px-0 overflow-hidden">
          <ul className="list-unstyled d-flex flex-column align-items-center mb-1">
            <li><h5 className="text-uppercase comp mb-1">{facility.name}</h5></li>
            <li><FacilityIcon facility={facility}/></li>
            <li><h5 className="mb-0 mt-1"><span className="facility-state">{stateDisplay}</span></h5></li>
            <li><h6 className="mb-0">
              {show_message() ? format_message() : "Time left: "}
              {!show_message() && <Timer targetTime={facility.target_time} targetReached={facility.target_reached}/>}
            </h6></li>
          </ul>
        </div>
        {isSuperuser &&
        <div className="col-auto px-0" style={{...infoPanelStyle, ...(showPanel ? openInfoPanelStyle : {})}}>
          {showPanel &&
          <ul className="list-unstyled mb-0 w-100" style={{fontSize: "0.6rem"}}>
            <li><span>Last update: {convertTimestampToDate(facility.update_time)} {convertTimestampToTime(facility.update_time)}</span></li>
            <li><span>Organisation: {facility.organisation}</span></li>
            <li><span>Recipe: {facility.current_recipe || "-"}</span></li>
            <li><span>Command: {facility.command ? <>{facility.command} ({convertTimestampToTime(facility.command_send_at)})</> : "-"}</span></li>
            <li><span>Return: {facility.remote || "-"}</span></li>
            <li><span>Coords: {facility.latitude}, {facility.longitude}</span></li>
            <li><span style={{fontSize: "0.5rem"}}>{facility.id}</span></li>
          </ul>}
        </div>}
      </div>
    </div>
  )
}

export default function FacilityPanel({activeFacility, setFacilityActive}) {
  const key = 'facility-panels-selected'
  const { items } = useStateTracker({
    url: '/api/v1/facility/',
    event: 'facility',
    query: {order_by: 'name'},
    filter: null
  })

  useEffect(() => {
    if (!activeFacility) return;
    localStorage.setItem(key, activeFacility.id);
  }, [activeFacility])

  useEffect(() => {
    const openTab = localStorage.getItem(key);
    if (openTab === null && items.length > 0) {
      setFacilityActive(items[0])
    }
    else {
      const idx = items.findIndex((facility) => openTab === facility.id);
      setFacilityActive(items[idx])
    }
  }, [items, setFacilityActive])

  return (
    <div className='container-fluid bg-gradient-primary w-100'>
      <div className='header facility-panels px-2 pt-2 mb-2'>
        <div className="tab-list row">
        {items.map(facility => (
          <FacilityTab
            key={facility.id}
            facility={facility}
            activeTab={activeFacility?.id}
            onClick={(facility) => setFacilityActive(facility)}
          />
        ))}
        </div>
        <hr className='mt-0 mb-2' />
      </div>
    </div>
  )
}